import * as React from "react"
import { Row, Col, Modal, Form } from "react-bootstrap"
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import GovPoolSelection from "../../../api/Randoms/GovPoolModel/GovPoolSelection"
import { GovPoolSelectionGet } from "../../../api/Randoms/GovPoolSelectionGet"
import GovPoolSelectionUpdate from "../../../api/Randoms/GovPoolSelectioUpdate"
import FormatDate from "../../../formatters/FormatDate"
import FormatError from "../../../formatters/FormatError"
import ActionButton from "../../ActionButton"
import { BirthdayInput } from "../../FormattedInputs/BirthdayInput"
import DaysToExclude from "../../../api/Randoms/GovPoolModel/DaysToExclude"
import { parseISO } from "date-fns"

type SelectionInterval = 'Monthly' | 'Weekly'

export interface GovPoolDateSelectedModalProps {
  onHide: () => void
  onSuccess: () => void
  dateSelected: Date
  dateSelectedID: number
  interval: SelectionInterval
  daysExcluded: DaysToExclude[]
}

interface GovPoolDateSelectedModalState {
  govPoolSelection?: GovPoolSelection
  dateSelected: Date
  maxDate: Date
  minDate: Date
}

export default class GovPoolDateSelected extends React.PureComponent<GovPoolDateSelectedModalProps, GovPoolDateSelectedModalState> {

  state: GovPoolDateSelectedModalState = {
    govPoolSelection: undefined,
    dateSelected: new Date(this.props.dateSelected),
    maxDate: new Date(),
    minDate: new Date()
  }

  govPoolSelectionSubcription?: Subscription
  govSelectionSubcriptionUpdate?: Subscription

  componentDidMount() {
    this.loadGovPoolSelection()
  }

  componentDidUpdate(prevProps: GovPoolDateSelectedModalProps) {
    if (this.props.dateSelectedID != prevProps.dateSelectedID) {
      this.loadGovPoolSelection()
    }
  }

  componentWillUnmount() {
    this.govPoolSelectionSubcription && this.govPoolSelectionSubcription.unsubscribe()
    this.govSelectionSubcriptionUpdate && this.govSelectionSubcriptionUpdate.unsubscribe()
  }

  loadGovPoolSelection() {
    this.govPoolSelectionSubcription = GovPoolSelectionGet(this.props.dateSelectedID).subscribe(
      (data: GovPoolSelection) => {
        let selectionPeriod = data?.SelectionPeriod
        let { minDate, maxDate } = this.calcDateRange()
        this.setState({ govPoolSelection: data, minDate: minDate, maxDate: maxDate })
      },
    )
  }

  addDays(date: Date, days: number): Date {
    var result = new Date(date)
    result.setDate(result.getDate() + days)
    return result
  }

  calcSelectionPeriod(dateEnd: Date, dateSelected: Date): number {
    let resultingDate = new Date(dateEnd.getTime() - dateSelected.getTime())
    return resultingDate.getDate()
  }

  calcDateRange() {
    let minDate = new Date()
    minDate.setDate(minDate.getDate() + 1)

    let maxDate = new Date()
    let selectionDays = this.props.interval === "Weekly" ? 7 : this.props.interval === "Monthly" ? 30 : 120
    maxDate = this.addDays(maxDate, selectionDays)

    return { minDate, maxDate }
  }

  onHide = () => { this.props.onHide() }

  dateValid = () => {
    return this.state.dateSelected
  }

  performSave = () => {
    this.govSelectionSubcriptionUpdate = GovPoolSelectionUpdate(FormatDate(this.state.dateSelected), this.props.dateSelectedID).subscribe(
      data => {
        toast.success(data)
        this.props.onSuccess()
      },
      (error) => {
        toast.error(FormatError(error))
      })
  }

  render() {
    const { dateSelected, maxDate, minDate } = this.state
    const weekdaysExcluded = this.props.daysExcluded.filter(item => item.DayOfWeekID).map(item => item.DayOfWeekID!)
    const datesExcluded = this.props.daysExcluded.filter(item => item.DateExclude).map(item => parseISO(item.DateExclude!).getTime())
    return (
      <Modal backdrop="static" show centered onHide={this.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>CHANGE DATE</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <Form.Row className="form-group p-3">
            <Col />
            <Form.Label column md={4}>Date Scheduled</Form.Label>
            <Col md={5}>
              <DatePicker className="form-control"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                minDate={minDate}
                maxDate={maxDate}
                selected={dateSelected}
                enableTabLoop={false}
                onChange={date => this.setState({ dateSelected: date as Date || undefined })}
                filterDate={date => !weekdaysExcluded.includes(date.getDay() + 1) && !datesExcluded.includes(date.getTime())}
                customInput={<BirthdayInput />}
              />
            </Col>
            <Col />
          </Form.Row>
        </Modal.Body>
        <Modal.Footer>
          <ActionButton variant="primary" onClick={this.performSave} disabled={!this.dateValid()} className="fixed-w5" >Save</ActionButton>
        </Modal.Footer>
      </Modal>
    )
  }
}
